var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearningMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 490C382.548 490 490 382.548 490 250C490 117.452 382.548 10 250 10C117.452 10 10 117.452 10 250C10 382.548 117.452 490 250 490Z",
    fill: "url(#paint0_radial_3_86)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M130 150C146.569 150 160 136.569 160 120C160 103.431 146.569 90 130 90C113.431 90 100 103.431 100 120C100 136.569 113.431 150 130 150Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M380 170C402.091 170 420 152.091 420 130C420 107.909 402.091 90 380 90C357.909 90 340 107.909 340 130C340 152.091 357.909 170 380 170Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M360 410C376.569 410 390 396.569 390 380C390 363.431 376.569 350 360 350C343.431 350 330 363.431 330 380C330 396.569 343.431 410 360 410Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M250 459C354.934 459 440 448.255 440 435C440 421.745 354.934 411 250 411C145.066 411 60 421.745 60 435C60 448.255 145.066 459 250 459Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 230C143.333 196.667 196.667 196.667 250 230V420C196.667 386.667 143.333 386.667 90 420V230Z",
    fill: "white",
    stroke: "#032746",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 230C303.333 196.667 356.667 196.667 410 230V420C356.667 386.667 303.333 386.667 250 420V230Z",
    fill: "white",
    stroke: "#032746",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 230V420",
    stroke: "#032746",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M250 230V420",
    stroke: "#6366F1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 260H220",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 280H220",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 300H220",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 320H220",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 340H190",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 360H210",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 380H200",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 260H380",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 280H380",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 300H380",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 320H380",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 340H350",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 360H370",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 380H360",
    stroke: "#032746",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 220C186.569 220 200 206.569 200 190C200 173.431 186.569 160 170 160C153.431 160 140 173.431 140 190C140 206.569 153.431 220 170 220Z",
    fill: "white",
    stroke: "#991B1B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 184H154V196H186V184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366 0H314C311.791 0 310 1.79086 310 4V36C310 38.2091 311.791 40 314 40H366C368.209 40 370 38.2091 370 36V4C370 1.79086 368.209 0 366 0Z",
    fill: "#F1F5F9",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 210C320 200 340 220 350 200C360 180 370 220 370 190",
    stroke: "#334155",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 205C322.761 205 325 202.761 325 200C325 197.239 322.761 195 320 195C317.239 195 315 197.239 315 200C315 202.761 317.239 205 320 205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 215C362.761 215 365 212.761 365 210C365 207.239 362.761 205 360 205C357.239 205 355 207.239 355 210C355 212.761 357.239 215 360 215Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 130C190 110 310 110 330 130L346 186C346 206 330 220 310 220H190C170 220 154 206 154 186L170 130Z",
    fill: "url(#paint1_linear_3_86)",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 126L230 146H270L294 126",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 126L190 186M294 126L310 186",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 146L220 186H280L270 146H230Z",
    fill: "#BFDBFE",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 154C176 159.333 176 164.667 180 170C184 164.667 184 159.333 180 154Z",
    fill: "#B10303",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 154C324 159.333 324 164.667 320 170C316 164.667 316 159.333 320 154Z",
    fill: "#B10303",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 244C207.255 244 218 233.255 218 220C218 206.745 207.255 196 194 196C180.745 196 170 206.745 170 220C170 233.255 180.745 244 194 244Z",
    fill: "#1F2937",
    stroke: "#0F172A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 244C319.255 244 330 233.255 330 220C330 206.745 319.255 196 306 196C292.745 196 282 206.745 282 220C282 233.255 292.745 244 306 244Z",
    fill: "#1F2937",
    stroke: "#0F172A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 232C200.627 232 206 226.627 206 220C206 213.373 200.627 208 194 208C187.373 208 182 213.373 182 220C182 226.627 187.373 232 194 232Z",
    fill: "#6B7280",
    stroke: "#374151",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 232C312.627 232 318 226.627 318 220C318 213.373 312.627 208 306 208C299.373 208 294 213.373 294 220C294 226.627 299.373 232 306 232Z",
    fill: "#6B7280",
    stroke: "#374151",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 224C196.209 224 198 222.209 198 220C198 217.791 196.209 216 194 216C191.791 216 190 217.791 190 220C190 222.209 191.791 224 194 224Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 224C308.209 224 310 222.209 310 220C310 217.791 308.209 216 306 216C303.791 216 302 217.791 302 220C302 222.209 303.791 224 306 224Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 190H280Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 190H280",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 160C220 170 280 180 250 190",
    stroke: "#1E293B",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 164C133.255 164 144 153.255 144 140C144 126.745 133.255 116 120 116C106.745 116 96 126.745 96 140C96 153.255 106.745 164 120 164Z",
    fill: "#1E293B",
    stroke: "#0F172A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 156C128.837 156 136 148.837 136 140C136 131.163 128.837 124 120 124C111.163 124 104 131.163 104 140C104 148.837 111.163 156 120 156Z",
    stroke: "#DFE3FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 124V132",
    stroke: "#DFE3FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 148V156",
    stroke: "#DFE3FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 140H112",
    stroke: "#DFE3FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 140H136",
    stroke: "#DFE3FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 0H364C361.791 0 360 1.79086 360 4V20C360 22.2091 361.791 24 364 24H400C402.209 24 404 22.2091 404 20V4C404 1.79086 402.209 0 400 0Z",
    fill: "#F1F5F9",
    stroke: "#64748B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 158H394",
    stroke: "#334155",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 166H394",
    stroke: "#334155",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M250 470C371.503 470 470 371.503 470 250C470 128.497 371.503 30 250 30C128.497 30 30 128.497 30 250C30 371.503 128.497 470 250 470Z",
    stroke: "#032746",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M250 450C360.457 450 450 360.457 450 250C450 139.543 360.457 50 250 50C139.543 50 50 139.543 50 250C50 360.457 139.543 450 250 450Z",
    stroke: "#032746",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3_86",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24010 24010) scale(33600)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_86",
    x1: 154,
    y1: 115,
    x2: 154,
    y2: 10615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B10303"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningMaterial);
export default __webpack_public_path__ + "static/media/Learning_Material.e5785a5bffed85c2bcfef7ec0194052a.svg";
export { ForwardRef as ReactComponent };